import groundingImage from "../../public/grounded-insights.png";
import { ImageWithFallback } from "./figma/ImageWithFallback";

export function Features() {
	return (
		<section id="features" className="relative overflow-hidden py-24 sm:py-28">
			<div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(circle_at_center,_rgba(210,244,238,0.55),_transparent_65%)]" />
			<div className="pointer-events-none absolute -top-32 left-0 h-72 w-72 rounded-full bg-[radial-gradient(circle,_rgba(15,157,138,0.25),_transparent_65%)] blur-3xl" />
			<div className="container mx-auto px-4 sm:px-6 lg:px-8">
				<div className="mx-auto mb-20 max-w-3xl text-center">
					<div className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/70 bg-white/70 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground shadow-sm shadow-primary/10 backdrop-blur-xl">
						<span className="h-2 w-2 rounded-full bg-primary" />
						<span>Momentum makers</span>
					</div>
					<h2 className="text-4xl sm:text-5xl">
						Everything your builders need to stay in flow
					</h2>
					<p className="mt-4 text-lg text-muted-foreground sm:text-xl">
						Transparent insights, grounded in real conversations, with just the
						right amount of sparkle to keep communities excited to contribute.
					</p>
				</div>

				<div className="mb-20 grid items-center gap-16 lg:grid-cols-2">
					<div className="order-2 lg:order-1">
						<div className="glass-panel relative h-[400px] overflow-hidden rounded-[32px] border border-white/70 shadow-float lg:h-[500px]">
							<ImageWithFallback
								src="/community-collaboration.png"
								alt="Community Collaboration"
								className="w-full h-full object-cover"
							/>
						</div>
					</div>

					<div className="order-1 space-y-6 lg:order-2">
						<h3 className="text-3xl sm:text-4xl">
							Built for{" "}
							<span className="text-primary">Developer Communities</span>
						</h3>
						<p className="text-lg text-muted-foreground sm:text-xl">
							We understand that building great communities is more than just
							metrics. It's about relationships, in-jokes, late-night pairings,
							and celebrating every ship together.
						</p>
						<p className="text-muted-foreground">
							Our AI agents are specifically designed for developer communities,
							to give you insights that actually matter, not just vanity
							metrics.
						</p>
					</div>
				</div>

				<div className="mb-20 grid items-center gap-16 lg:grid-cols-2">
					<div className="space-y-6">
						<h3 className="text-3xl sm:text-4xl">
							<span className="text-primary">Instant Action Items</span> That
							Matter
						</h3>
						<p className="text-lg text-muted-foreground sm:text-xl">
							No more sifting through endless conversations. Our AI
							automatically surfaces what needs your attention right now.
						</p>
						<p className="text-muted-foreground">
							Get categorized action items from your community: bug reports,
							feature requests, documentation improvements, and support needs.
							Each item is tagged, dated, and linked to the actual
							conversations.
						</p>
					</div>

					<div className="order-2 lg:order-1">
						<div className="glass-panel relative h-[400px] overflow-hidden rounded-[32px] border border-white/70 shadow-float lg:h-[500px]">
							<ImageWithFallback
								src="/community-action-items.png"
								alt="AI-generated action items from community conversations"
								className="w-full h-full object-cover"
							/>
						</div>
					</div>
				</div>

				<div className="grid items-center gap-16 lg:grid-cols-2">
					<div className="order-2 lg:order-1">
						<div className="glass-panel relative h-[400px] overflow-hidden rounded-[32px] border border-white/70 shadow-float lg:h-[500px]">
							<ImageWithFallback
								src={groundingImage}
								alt="Every insight grounded in real community conversations"
								className="w-full h-full object-cover object-left"
							/>
						</div>
					</div>

					<div className="order-1 space-y-6 lg:order-2">
						<h3 className="text-3xl sm:text-4xl">
							Grounded in{" "}
							<span className="text-primary">Real Conversations</span>
						</h3>
						<p className="text-lg text-muted-foreground sm:text-xl">
							Every insight, every action item, every recommendation is backed
							by actual community discussions.
						</p>
						<p className="text-muted-foreground">
							See exactly which threads, who said what, and when. No black box
							AI - just transparent insights you can verify and act on with
							confidence.
						</p>
					</div>
				</div>
			</div>
		</section>
	);
}
